module.exports = __webpack_public_path__ + "static/media/snowman.07f66fd1.glb";